var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-padding" }, [
    _c(
      "div",
      {
        staticClass: "spaceBetween",
        staticStyle: { "margin-bottom": "0.24rem" },
      },
      [
        _c(
          "div",
          { staticClass: "spaceLeft" },
          [
            _c("div", { staticClass: "detail-title-1" }, [
              _vm._v("Auction Pool"),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "upper b-c",
                staticStyle: { "margin-left": "0.16rem" },
                attrs: { type: "text" },
                on: { click: _vm.toBidList },
              },
              [
                _vm._v("My bidding history "),
                _c("i", { staticClass: "el-icon-d-arrow-right" }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spaceLeft search-form" },
          [
            _c("search-date", {
              attrs: { label: "Closing time" },
              on: {
                dateChange: function ($event) {
                  return _vm.dateChange($event, "overtime")
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sapceLeft search-item" },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "No...",
                    "suffix-icon": "el-icon-search",
                  },
                  on: { change: _vm.getList },
                  model: {
                    value: _vm.searchParams.number,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "number", $$v)
                    },
                    expression: "searchParams.number",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "common-card is-border" }, [
      _c(
        "div",
        { staticClass: "common-card-main" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "number", label: "Bid No.", align: "left" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "Auction", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.amount } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("UNIT"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "startAmount",
                  label: "Reserve price",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", {
                          attrs: { number: row.startAmount },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("TCash"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "overtime",
                  label: "Closing time",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm
                                .moment(row.overtime)
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "highValue",
                  label: "Current bid",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.highValue } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("TCash"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "operation",
                  label: "operation",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "o-btn",
                            on: {
                              click: function ($event) {
                                return _vm.toPlaceBid(row)
                              },
                            },
                          },
                          [_c("span", [_vm._v("Place a bid")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.queryParams.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getList()
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }